import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import RentalList from "./RentalList";
import rentalSolution from "../../Assets/images/rental-payment.png";
import AllApartClasses from "./AllApartClasses";

function Content() {
  const location = useLocation();
  const [openSavedApartment, setOpenSavedApartment] = useState(false);
  const [savedApartmentData, setSavedApartmentData] = useState(null);

  useEffect(() => {
    if (location.state?.selectedSavedApartment) {
      setSavedApartmentData(location.state.selectedSavedApartment);
      setOpenSavedApartment(true);
      // clean up state so it doesn't reopen on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const handleCloseSavedApartment = () => {
    setOpenSavedApartment(false);
  };

  return (
    <div>
      <AllApartClasses 
        open={openSavedApartment} 
        handleClose={handleCloseSavedApartment} 
        data={savedApartmentData}
      />
      <div className=" grid gap-4 md:grid-cols-2">
        <div className="rounded border shadow-lg bg-[#FFFFFF] p-3 h-auto md:h-[100vh] overflow-y-auto scrollbar-hide">
          <div className="p-2 rounded-md">
            <img className=" w-[100%]" src={rentalSolution} alt="rentals" />
          </div>
          <div>
            <RentalList />
          </div>
        </div>
        <div className="rounded border shadow-lg bg-[#FFFFFF] p-3 h-auto md:h-[100vh] overflow-y-auto scrollbar-hide">
          <div className=" grid grid-cols-2 mb-5">
            <NavLink
              className={({ isActive }) => {
                return (
                  " text-back-color2 py-2 border rounded-[4px] px-6 " +
                  (!isActive ? " bg-[#F7F8FB] " : " border-gray-200  bg-white ")
                );
              }}
              to="active"
            >
              <p>Active rent</p>
            </NavLink>
            <NavLink
              className={({ isActive }) => {
                return (
                  " text-back-color2 py-2 border rounded-[4px] px-6 " +
                  (!isActive ? " bg-[#F7F8FB] " : " border-gray-200  bg-white ")
                );
              }}
              to="pending"
            >
              <p>Pending rent</p>
            </NavLink>
          </div>
          <div className="pb-5">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Content;
